import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_WARD } from "src/constants/actionCache";
import WardPopup from "../Popup/WardPopup";
import ShowCacheWard from "../ShowCache/ShowCacheWard";

const WardControlPanel = ({
  currentActionCache,
  openPopup,
  setOpenPopup,
  recordForEdit,
  addOrEdit,
  handleOpenPopup,
  provinceId,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        margin: "20px 0 10px 0",
      }}
    >
      <DeployCache
        title="Cache District"
        isShowButton={isShowCache(currentActionCache, CACHE_WARD)}
      >
        <ShowCacheWard
          disableButton={disableButton}
          setDisableButton={setDisableButton}
        />
      </DeployCache>

      <WardPopup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        handleOpenPopup={handleOpenPopup}
        provinceId={provinceId}
      />
    </div>
  );
};

export default WardControlPanel;
